import { Box, Grid, Slider, SliderFilledTrack, SliderMark, SliderThumb, SliderTrack } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { Color } from 'src/theme/color';
import { SmallHeading } from 'src/components/common/texts/SmallHeading/smallHeading';

export const SetPrice = () => {
	const { values, setFieldValue } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setPriceAndFee.label')}>{t('form.steps.setPriceAndFee.heading')}</FormSectionHeading>
				<Grid
					templateColumns="auto"
					gridGap="20px"
					w="100%"
				>
					<InputField
						label={t('form.fields.unitPrice')}
						name="price"
						placeholder="10$"
						leftText="$"
					/>
					
					<SmallHeading text={t('form.fields.transferFee')} />
					<Slider
						w="100%%"
						mt="-14px"
						aria-label="slider-ex-1"
						defaultValue={(values as any).transferFee}
						max={(values as any).cartridge == "gold" ? 20 : 100} //@TODO
						min={0}
						h="11px"
						onChange={val => setFieldValue('transferFee', val)}
					>
						<SliderTrack
							bg={`repeating-linear-gradient(to right, ${Color.GRAY_3} 0px, ${Color.GRAY_3} 2px, transparent 2px, transparent 4px)`}
							h="11px"
						>
							<SliderFilledTrack
								h="11px"
								bg={`repeating-linear-gradient(to right, ${Color.HASHUP} 0px, ${Color.HASHUP} 2px, transparent 2px, transparent 4px)`}
							/>
						</SliderTrack>
						<SliderMark
							value={(values as any).transferFee}
							textAlign="center"
							bg="transparent"
							color="white"
							mt="14px"
							ml="-13px"
							w="30px"
							fontSize="12px"
							fontWeight="bold"
						>
							{(values as any).transferFee}
							<Box
								display="inline"
								color={Color.HASHUP}
							>
								%
							</Box>
						</SliderMark>
						<SliderThumb
							border="none"
							bg="none"
							w="24px"
							borderRadius="6px"
						>
							<Box
								w="24px"
								h="15px"
								bg={Color.HASHUP_2}
								borderRadius="6px"
								border={`2px solid ${Color.HASHUP}`}
							></Box>
						</SliderThumb>
					</Slider>
				</Grid>
				<FormSectionAddon>
					<Box>{t('form.headers.metadata.description')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<Grid alignItems="center" justifyItems="center">
					<Box>	{t('form.steps.setPriceAndFee.calculation')} {((1)/(1-(values as any).transferFee/100) + 0.01).toFixed(2)} {((values as any).symbol)}</Box>
				</Grid>
			
			</RightColumn>
		</TwoColumn>
	);
};
